import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/esnext.json.parse.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
let _ = require('lodash');
import { mapState, mapGetters, mapMutations } from 'vuex';
import { getImg, getformListItemsdatas } from '@/utils/utils';
export default {
  name: 'routelist',
  emits: ['route'],
  props: {
    typelist: {
      type: Array,
      default: []
    },
    routelist: {
      type: Array,
      default: []
    },
    pointlist: {
      type: Array,
      default: []
    },
    style: {
      type: Object,
      default: {}
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      tIndex: 0,
      dataList: [],
      rIndex: '',
      showlistflag: false,
      lock: false,
      pointform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 点位查询字段集合
      pointList: []
    };
  },
  computed: {
    ...mapGetters(['mapv2info'])
  },
  watch: {
    typelist: {
      handler(val) {
        if (val.length > 0) {
          this.$nextTick(() => {
            this.swiperEl = new Swiper(this.$refs.swipercontainer, {
              initialSlide: 0,
              slidesPerView: 'auto',
              observeSlideChildren: true,
              observeParents: true,
              observer: true,
              navigation: {
                nextEl: this.$refs.swiperbuttonnext,
                prevEl: this.$refs.swiperbuttonprev
              }
            });
          });
        }
      },
      deep: true
    },
    routelist: {
      handler(val) {
        if (this.typelist.length > 0) {
          this.dataList = val.filter(item => {
            return item.itemformdata.typeId === this.typelist[0].itemformdata.onlyid;
          });
        }
      },
      deep: true
    },
    'style.routepopcolor': {
      handler(val) {
        if (val) {
          document.documentElement.style.setProperty('--hand-drawn-routepop-colortheme1', val);
        }
      },
      deep: true
    },
    'mapv2info.style.routepopcolor': {
      handler(val) {
        if (val) {
          document.documentElement.style.setProperty('--hand-drawn-routepop-colortheme1', val);
        }
      },
      deep: true
    }
  },
  mounted() {
    this.pointform.deptId = this.$route.query.fid;
  },
  methods: {
    typeClick(item, i) {
      this.tIndex = i;
      this.rIndex = '';
      this.dataList = this.routelist.filter(elem => {
        return elem.itemformdata.typeId === item.itemformdata.onlyid;
      });
      // this.$emit('route', this.dataList)
    },
    getPoint(json) {
      let data = {
        ...JSON.parse(json.replace(/(<\/?p.*?>)/gi, ''))
      };
      return data.routedata;
    },
    routeClick(item) {
      this.rIndex = this.rIndex === item.id ? '' : item.id;
      this.$emit('route', {
        cItem: this.rIndex !== '' ? [item] : [],
        data: this.pointList
      });
    },
    getrouteBtnstyle(val) {
      let pos = val.routepos !== undefined ? {
        ...val.routepos
      } : {
        ...this.mapv2info.style.routepos
      };
      let other = val.routebtn !== undefined ? {
        ...val.routebtn
      } : {
        ...this.mapv2info.style.routebtn
      };
      if (Object.keys(pos).length > 0 && Object.keys(other).length > 0) {
        let data = {
          ...other[0]
        };
        if (data.imgList && data.imgList.length > 0) {
          data.backgroundImage = 'url(\'' + getImg(data.imgList[0]) + '\')';
          data.backgroundSize = '100% 100%';
          data.backgroundRepeat = 'no-repeat';
        }
        data.textAlign = 'center';
        delete data.imgList;
        let formatData = Object.assign({}, pos, data);
        Object.keys(formatData).forEach(child => {
          if (this.isMobile) {
            formatData[child] = /px$/.test(formatData[child]) ? `${parseFloat((parseInt(formatData[child]) / 2 / 37.5).toFixed(6))}rem` : formatData[child];
          } else {
            formatData[child] = /px$/.test(formatData[child]) ? `${parseFloat((parseInt(formatData[child]) / 1920 * 100).toFixed(6))}vw` : formatData[child];
          }
        });
        return formatData;
      }
    },
    routebtnHide() {
      this.showlistflag = false;
      this.rIndex = '';
      this.typeClick(this.typelist[0], 0);
    },
    routebtnHandle() {
      if (this.pointList.length === 0) {
        this.getpointData();
        return;
      }
      this.showfirstroutedata();
    },
    closeroutelist() {
      this.routebtnHide();
      this.$emit('route', []);
    },
    showfirstroutedata() {
      this.showlistflag = true;
      this.rIndex = '';
      this.typeClick(this.typelist[0], 0);
      this.routeClick(this.dataList[0]);
    },
    /**
     * 获取地点管理表数据
     */
    getpointData() {
      let that = this;
      this.$api.singleadvanceSearch(this.pointform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.pointform.page === 1) that.pointList = [];
          let dataList = that.formdataformat(res);
          that.pointList = that.pointform.page === 1 ? dataList : that.pointList.concat(dataList);
          if (res.totalPage > 1) that.pointform.page++;
          if (res.totalPage === 1 || res.totalPage === that.pointform.page) that.showfirstroutedata();
          if (res.totalPage > 1 && res.totalPage >= that.pointform.page) that.getpointData();
        }
      });
    },
    formdataformat(res) {
      return res.dataList.map((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        return item;
      });
    }
  }
};